import { render } from "./SelfAssessmentV2Encouragement.vue?vue&type=template&id=8d8da470&scoped=true"
import script from "./SelfAssessmentV2Encouragement.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Encouragement.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Encouragement.vue?vue&type=style&index=0&id=8d8da470&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8da470"]])

export default __exports__